import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import { ItemLayer } from '.';
import { SVGSprite } from '../flash/display';

export default class MeasureLayer extends ItemLayer {
    parent: marietta.webcad.layer.FloorLayer;

    groupSpt: SVGSprite;

    groupObj: Element;

    /**
     * コンストラクタ
     */
    constructor(_no: number, _name: string, _key: string, layer: SVGSprite, parent: marietta.webcad.layer.FloorLayer) {
      super(_no, _name, _key, layer);
      this.parent = parent;

      // 形状の生成
      this.groupObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.groupSpt = new SVGSprite(this.groupObj);
      this.spt.element.append(this.groupObj);
    }

    /**
     * 初期化
     */
    initMe() {
      while (this.groupSpt.element.firstChild) {
        this.groupSpt.element.removeChild(this.groupSpt.element.firstChild);
      }
    }

    /**
     * 描画
     */
    drawMeasure(measureLineData) {
      if (measureLineData == null) return;

      const myFloor: string = String(this.parent.floor);
      for (let k = 0, len3 = measureLineData.length; k < len3; k += 1) {
        this.createSunpou(measureLineData[k], myFloor, k.toString());
      }
    }

    /**
     * 描画
     */
    createSunpou(infoObj: marietta3d.AutoGen.object.AutoObjDimension, floorNum: string, indexNum: string) {
      // 位置の初期化
      this.initializePosition();

      // 頂点の整理（線を引くポイント順）
      const p1: marietta.core.Point = new marietta.core.Point(infoObj.p1.x, infoObj.p1.y);
      const p1w: marietta.core.Point = new marietta.core.Point(infoObj.p1w.x, infoObj.p1w.y);
      const p2: marietta.core.Point = new marietta.core.Point(infoObj.p2.x, infoObj.p2.y);
      const p2w: marietta.core.Point = new marietta.core.Point(infoObj.p2w.x, infoObj.p2w.y);
      const ashiPoint: marietta.core.Point = new marietta.core.Point(infoObj.p2.x - infoObj.p1.x, infoObj.p2.y - infoObj.p1.y);
      const pointList = [
        p1w,
        p1,
        p2,
        p2w,
      ];

      // y座標修正
      for (let j = 0; j < pointList.length; j += 1) {
        pointList[j].y = -(pointList[j].y) + marietta.webcad.WebCADGlobal.LAYER_SIZE_H;
      }

      // let strokeWidth = 1 / marietta.webcad.WebCADGlobal.scaleSize;
      const strokeWidth = 1;

      // ラインの作成
      for (let i = 0; i < 3; i += 1) {
        const pathEl: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathEl.setAttribute('stroke', '#000000');
        pathEl.setAttribute('stroke-width', strokeWidth.toString());
        pathEl.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(pointList[i], pointList[i + 1]));
        pathEl.setAttribute('id', `measureline_${floorNum}_${indexNum}_${i + 1}`);

        this.groupSpt.element.appendChild(pathEl);
      }

      // 線に合わせて文字を表示
      // 表示する文字（距離）を取得
      // let lineLen = marietta.core.Point.distance(p1, p2);
      const lenText = infoObj.dimStr;
      const defsNode: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      const defsPathNode: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const gNode: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      const textNode: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      const textPathNode: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');

      defsPathNode.setAttribute('id', `measureline_lib_${floorNum}_${indexNum}_${2}`);
      textNode.setAttribute('text-anchor', 'middle');
      textNode.setAttribute('fill', '#000000');
      textNode.setAttribute('dy', '-5');
      textNode.setAttribute('font-size', '12px');
      textPathNode.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', `#measureline_lib_${floorNum}_${indexNum}_${2}`);
      textPathNode.setAttribute('startOffset', '50%');
      textPathNode.textContent = lenText;

      defsNode.appendChild(defsPathNode);
      this.groupSpt.element.appendChild(defsNode);

      textNode.appendChild(textPathNode);

      if (marietta.core.Point.distance(pointList[1], pointList[2]) > 14) {
        gNode.appendChild(textNode);
      }

      this.groupSpt.element.appendChild(gNode);

      // 左右
      if (Math.abs(ashiPoint.x) < Math.abs(ashiPoint.y)) {
        if (infoObj.p1w.x > infoObj.p1.x) {
          defsPathNode.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(pointList[2], pointList[1]));
        } else {
          defsPathNode.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(pointList[1], pointList[2]));
        }
      } else {
        // 上下
        // eslint-disable-next-line no-lonely-if
        if (infoObj.p1w.y > infoObj.p1.y) {
          defsPathNode.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(pointList[1], pointList[2]));
        } else {
          defsPathNode.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(pointList[2], pointList[1]));
        }
      }
    }

    /**
     * 寸法線の有無
     */
    hasMeasureLine(): boolean {
      return (this.groupSpt.element).children.length > 0;
    }

    /**
     * レイヤーを非表示
     */
    hide() {
      (this.spt.element).style.display = 'none';
    }

    /**
     * レイヤーを表示
     */
    show() {
      (this.spt.element).style.display = 'block';
    }

    /**
     * 全てのアイテムの移動
     * */
    initializePosition(): void {
      this.groupSpt.x = 0;
      this.groupSpt.y = 0;
      this.groupSpt.update();
    }

    /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
    moveAllItems(moveX: number, moveY: number): void {
      this.groupSpt.x += moveX;
      this.groupSpt.y += moveY;
      this.groupSpt.update();
    }
}
